export const Snackbar = {
    DEFAULT_DURATION: 2000
};
